import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";

import ProductOptionSwatch from "./product-option-swatch";
import ProductOptionSummary from "./product-option-summary";
import ProductOptionPreview from "./product-option-preview";

export default function ProductOptionSwatches({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  selectedVariant,
  openByDefault,
  last,
  enableSwatchPreview,
}) {
  const [previewOpen, setPreviewOpen] = useState(false);

  const optionInGroupSelected = optionValues.some(
    (optionValue) => optionValue.name === selectedOptionValue,
  );

  return (
    <conditional-details>
      <details
        className={`product-options__option-details ${last ? "product-options__option-details--last" : ""} product-options__swatches`}
        open={openByDefault}
      >
        <ProductOptionSummary
          optionName={optionName}
          selectedOptionValue={selectedOptionValue}
          optionValuesCount={optionValues.length}
        />
        <div className="product-options__option-content" data-content>
          <div className="product-options__option-content-inner">
            {enableSwatchPreview && (
              <ProductOptionPreview
                selectedVariant={selectedVariant}
                selectedOptionValue={selectedOptionValue}
                open={previewOpen}
                setOpen={setPreviewOpen}
                optionInGroupSelected={optionInGroupSelected}
              />
            )}
            <fieldset className="product-options__swatch-list">
              <legend className="visually-hidden">{optionName}</legend>
              {optionValues.map((optionValue) => (
                <ProductOptionSwatch
                  key={optionValue.name}
                  optionValue={optionValue}
                  optionName={optionName}
                  disabled={disabledOptionValues.includes(optionValue.name)}
                  updateOptionValue={updateOptionValue}
                  selected={optionValue.name === selectedOptionValue}
                  onClick={() => setPreviewOpen(true)}
                />
              ))}
            </fieldset>
          </div>
        </div>
      </details>
    </conditional-details>
  );
}
